import * as yup from "yup";

export const tableSchema = yup.object({
  adminFeeStartingYear: yup
    .number()
    .required()
    .typeError("Admin Fee Starting  is Required"),
  assetManagement: yup
    .number()
    .required()
    .typeError("Asset Management is Required"),
  equityContribution: yup
    .number()
    .required()
    .typeError("Equity Contribution is Required"),
  assumedPercentageInveterWarranty: yup
    .number()
    .required()
    .typeError("Assumed Percentage Inveter Warranty is Required"),
  costPerExtendedInveterWarranty: yup
    .number()
    .required()
    .typeError("Cost Per Extended Inveter Warranty is Required"),
  developerDepositPayment1: yup
    .number()
    .required()
    .typeError("Developer Deposit Payment 1 is Required"),
  developerDepositPayment2: yup
    .number()
    .required()
    .typeError("Developer Deposit Payment 2 is Required"),
  developerDepositPayment3: yup
    .number()
    .required()
    .typeError("Developer Deposit Payment 3 is Required"),
  developerDevFee: yup
    .number()
    .required()
    .typeError("Developer Dev Fee is Required"),
  federalBonusDepreciation: yup
    .number()
    .required()
    .typeError("Federal Bonus Derreciation is Required"),
  federalBonusDepreciationPercent: yup
    .number()
    .required()
    .typeError("Federal Bonus Depreciation Percent is Required"),
  itcPercent: yup.number().required().typeError("ITC Percent is Required"),
  marginalFedTaxRate: yup
    .number()
    .required()
    .typeError("Marginal Fed Tax Rate is Required"),
  pPATerm: yup.number().required().typeError("PPA is Required"),
  percentagePropertyOwnerPurchases: yup
    .number()
    .required()
    .typeError("Percentage Property Owner Purchases is Required"),
  solarDegradation: yup
    .number()
    .required()
    .typeError("Solar Degradation is Required"),
  yrsAdminFeeEscalator: yup
    .number()
    .required()
    .typeError("Yrs Admin Fee Escalator is Required"),
  pandcCost: yup.number().required().typeError("PandC Cost is Required"),
  ppaPercentOfBillOfSale: yup
    .number()
    .required()
    .typeError("PPA % of Bill of Sale is Required"),
  ppaPercentOfTurnkey: yup
    .number()
    .required()
    .typeError("PPA % of Turnkey is Required"),
  turnkeyDC: yup.number().required().typeError("Turnkey $/W DC is Required"),
  percentOfPPAIncome: yup
    .number()
    .required()
    .typeError("Percent Of PPA Income is Required"),
  sizeKWDc: yup.number().required().typeError("Size KWDc  is Required"),
  reverseForExpenseInExcess: yup
    .number()
    .required()
    .typeError("Reverse For Expense In Excess is Required"),
  wholesaleReplecement: yup
    .number()
    .required()
    .typeError("Wholesale Replecement is Required"),
  replecementEscalator: yup
    .number()
    .required()
    .typeError("Replecement Escalator is Required"),
  feeCustomerDCPerYear: yup
    .number()
    .required()
    .typeError("Fee Customer DC per year is Required"),
  portfolioAve: yup.number().required().typeError("Portfolio Ave is Required"),
});
export const MacrsSchema = yup.object({
  macrsDRYear1: yup.number().required().typeError("Year 1 is Required*"),
  macrsDRYear2: yup.number().required().typeError("Year 2 is Required*"),
  macrsDRYear3: yup.number().required().typeError("Year 3 is Required*"),
  macrsDRYear4: yup.number().required().typeError("Year 4 is Required*"),
  macrsDRYear5: yup.number().required().typeError("Year 5 is Required*"),
  macrsDRYear6: yup.number().required().typeError("Year 6 is Required*"),
});
const depreciationRate = yup
  .number()
  .typeError("Depreciation rate must be a number")
  .min(0, "Depreciation rate must be at least 0%")
  .max(100, "Depreciation rate must be at most 100%");
export const stateSchema = yup.object({
  state: yup.string().required().typeError("State is Required*"),
  stateTaxRatePercent: yup
    .number()
    .typeError("Depreciation rate must be a number")
    .required("State Tax Percent is required*")
    .typeError("State Tax Percent is required*")
    .min(0, "State Tax Percent must be at least 0%")
    .max(100, "State Tax Percent cannot exceed 100%"),

  stateTaxRatePercentYrs7_20: yup
    .number()
    .typeError("Depreciation rate must be a number")
    .required("State Tax Rate Percent yrs is required*")
    .typeError("State Tax Rate Percent yrs is required*")
    .min(0, "State Tax Rate Percent yrs must be at least 0%")
    .max(100, "State Tax Rate Percent yrs cannot exceed 100%"),

  statePTEPaymentPercent: yup
    .number()
    .typeError("Depreciation rate must be a number")
    .required("State PTE Payment Percent is required*")
    .typeError("State PTE Payment Percent is required*")
    .min(0, "State PTE Payment Percent must be at least 0%")
    .max(100, "State PTE Payment Percent cannot exceed 100%"),

  stateBonusDepreciation: yup
    .string()
    .required()
    .typeError("State Bonus Depreciation is Required*"),
  stateDepreciation: yup
    .string()
    .required()
    .typeError("State Depreciation is Required*"),
  stateRevenueSpread: yup.string(),
  depRateY1: depreciationRate,
  depRateY2: depreciationRate,
  depRateY3: depreciationRate,
  depRateY4: depreciationRate,
  depRateY5: depreciationRate,
  depRateY6: depreciationRate,
  lossLimitations: yup.number().typeError("Loss Limitations must be a number"),
  fedDepAddBack: yup.number().typeError("Fed Dep Add Back must be a number"),
});
export const resetSchema = yup.object({
  password: yup
    .string()
    .min(8, "Password should be 8 characters long")
    .required("Password is required*")
    .label("Password"),
  confirmPassword: yup
    .string()
    .required("Confirm Password is required")
    .oneOf([yup.ref("password")], "Passwords must match")
    .label("Confirm Password"),
});
export const subAdminSchema = yup.object({
  name: yup.string().required("Name is required").label("Name"),
  password: yup
    .string()
    .min(8, "Password should be 8 characters long")
    .required("Password is required*")
    .label("Password"),
});
export const reportInputSchema = yup.object({
  equalityContribution: yup.string().when("grossIncome", {
    is: (grossIncome) => !grossIncome,
    then: () => yup.string().required("Equity Contribution is required*"),
  }),
  grossIncome: yup.string().optional(),
  stateId: yup.string().required("State is required*"),
  estFederalTaxRate: yup
    .string()
    .required("Estimated Federal Tax Rate is required*"),
});

export const replySchema = yup.object({
  reply: yup.string().trim().required("Reply is required"),
});

export const zohoIdSchema = yup.object({
  zohoId: yup.string().trim().required("Zoho Id is required"),
});

export const contactOwner = yup.object({
  userId: yup.string().trim().required("User Id is required"),
  ownerName: yup.string().trim(),
  ownerRole: yup.string().trim(),
  ownerPhone: yup.string().trim(),
  ownerEmail: yup.string().trim(),
  subOwnerName: yup.string().trim(),
  subOwnerRole: yup.string().trim(),
  subOwnerEmail: yup.string().trim(),
  subOwnerPhone: yup.string().trim(),
});

export const proformaUser = yup.object({
  userName: yup.string().trim().required("User Name is required"),
  pin: yup.number().typeError("Pin is required").required("Pin is required"),
  contactGroup: yup
    .string()
    .test("required", "Contact Group is required", function (value, context) {
      if (context.options.context?.isExternal && !value) {
        return this.createError({
          message: "Contact Group is required",
        });
      }
      return true;
    }),
});

export const contactGroup = yup.object({
  contactGroupName: yup
    .string()
    .trim()
    .required("Contact group name is required"),
  folderId: yup.string().trim().required("Folder ID is required"),
  developerDevFee: yup
    .string()
    .trim()
    .required("Developer dev Fee is required"),
  itcPercent: yup.string().trim().required("ITC Percent is required"),
  email: yup
    .string()
    .trim()
    .test(
      "valid-email-format",
      "Enter valid email(s) separated by a space",
      (value) => {
        if (!value || value.trim() === "") return true; // Skip validation if empty
        return /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\s+[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*$/.test(
          value
        );
      }
    )
    .test(
      "unique-emails",
      "Email(s) must be unique (case-insensitive)",
      (value) => {
        if (!value || value.trim() === "") return true; // Skip validation if empty
        const emails = value.split(/\s+/); // Split emails by space
        const normalizedEmails = emails.map((email) => email.toLowerCase()); // Normalize to lowercase
        const uniqueEmails = new Set(normalizedEmails); // Use Set to find duplicates
        return uniqueEmails.size === normalizedEmails.length; // Check for duplicates
      }
    ),
});

export const emailValidationSchema = yup.object({
  email: yup
    .string()
    .trim()
    .matches(
      /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\s+[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*$/,
      "Enter valid email(s) separated by a space"
    )
    .required("Email(s) is required")
    .test(
      "unique-emails",
      "Email(s) must be unique (case-insensitive)",
      (value) => {
        if (!value) return true;
        const emails = value.split(/\s+/);
        const normalizedEmails = emails.map((email) => email.toLowerCase());
        const uniqueEmails = new Set(normalizedEmails);
        return uniqueEmails.size === normalizedEmails.length;
      }
    ),
});

export const productionReportSchema = yup.object({
  // These fields are excluded from the form but included in the final submission
  recordId: yup.string().optional(),
  recordIdDeal: yup.string().optional(),
  assetId: yup.string().optional(),

  // These fields are included in the form and validated
  dealName: yup.string().trim().required("Deal Name is required"),
  monthYear: yup.string().trim().required("Month-Year is required"),
  measurementType: yup.string().trim().required("Measurement Type is required"),
  actualEstimatedPercent: yup
    .number()
    .typeError("Actual / Estimated % must be a number")
    .required("Actual / Estimated % is required"),
  actualProduction: yup
    .number()
    .typeError("Actual Production must be a number")
    .required("Actual Production is required"),
  netEstimate: yup
    .number()
    .typeError("Net Estimate must be a number")
    .required("Net Estimate is required"),
});

export const trancheForm = yup.object().shape({
  assetDealSource: yup.string().required("Asset Provider is required"),
  itcPercent: yup
    .number()
    .typeError("ITC percent must be a number")
    .required("ITC percent is required")
    .min(0, "ITC percent must be at least 0%")
    .max(100, "ITC percent cannot exceed 100%"),

  states: yup.array().of(yup.string()).min(1, "Select at least one state"),

  internalMarkupPercent: yup
    .number()
    .typeError("Internal Markup must be a number")
    .required("Internal Markup percent is required")
    .min(0, "Internal Markup percent must be at least 0%")
    .max(100, "Internal Markup percent cannot exceed 100%"),

  affiliateMarkupPercent: yup
    .number()
    .typeError("Affiliate Markup must be a number")
    .required("Affiliate Markup percent is required")
    .min(0, "Affiliate Markup percent must be at least 0%")
    .max(100, "Affiliate Markup percent cannot exceed 100%"),
});

const validationSchema = yup
  .object({
    required: yup.boolean().required("Asset validation is required."),
    minLength: yup
      .number()
      .nullable()
      .optional()
      .transform((value) => (Number.isNaN(value) ? undefined : value)),
    maxLength: yup
      .number()
      .nullable()
      .optional()
      .transform((value) => (Number.isNaN(value) ? undefined : value)),
    min: yup
      .number()
      .nullable()
      .optional()
      .transform((value) => (Number.isNaN(value) ? undefined : value)),
    max: yup
      .number()
      .nullable()
      .optional()
      .transform((value) => (Number.isNaN(value) ? undefined : value)),
    pattern: yup.array().of(yup.string()).optional(),
  })
  .optional();

export const assetColumnSchema = yup.object().shape({
  label: yup
    .string()
    .trim()
    .required("Column name is required")
    .min(1, "Column name cannot be empty"),
  csvLabel: yup
    .array()
    .of(yup.string().nullable()) // Allow strings, null, or undefined in the array
    .optional() // Make the field optional (can be undefined)
    .nullable() // Allow null for the entire array
    .transform((value, originalValue) => {
      // Handle case where input is a single string or malformed data
      if (typeof originalValue === "string") {
        return [originalValue]; // Convert single string to array
      }
      // Filter out null/undefined/empty strings if desired
      return value ? value.filter((item) => item != null && item !== "") : [];
    }),
  zohoLabel: yup
    .mixed()
    .optional()
    .transform((value, originalValue) => {
      if (
        Array.isArray(value) &&
        value.length === 1 &&
        typeof value[0] === "string"
      ) {
        return value[0].replace(/^"|"$/g, "");
      }
      if (typeof value === "string") {
        return value.replace(/^"|"$/g, "");
      }
      return null;
    })
    .nullable()
    .test("is-string", "Zoho label must be a string", (value) => {
      return value === undefined || value === null || typeof value === "string";
    }),
  dataType: yup
    .string()
    .oneOf(
      ["string", "number", "boolean"],
      "Data type must be one of: string, number, boolean"
    )
    .required("Data type is required"),
  // validation: validationSchema,
  defaultValue: yup.string().trim().optional(),
  isFormula: yup.boolean().optional(),
  formula: yup.string().optional(),
  dependencies: yup.array().of(yup.string()).optional(),
});

// export const getAssetColumnSchema = (dataType, enableValidation) => {
//   let validationFields = {};

//   if (enableValidation) {
//     if (dataType === "string") {
//       validationFields.minLength = yup
//         .number()
//         .typeError("Min length must be a number")
//         .min(0, "Min length must be 0 or more")
//         .optional();

//       validationFields.maxLength = yup
//         .number()
//         .typeError("Max length must be a number")
//         .moreThan(
//           yup.ref("minLength"),
//           "Max length must be greater than min length"
//         )
//         .optional();
//     }

//     if (dataType === "number") {
//       validationFields.min = yup
//         .number()
//         .typeError("Min must be a number")
//         .optional();

//       validationFields.max = yup
//         .number()
//         .typeError("Max must be a number")
//         .moreThan(yup.ref("min"), "Max must be greater than min")
//         .optional();
//     }
//   }

//   return yup.object().shape({
//     // label: yup.string().required("Column name is required"),
//     // csvLabel: yup.string().required("CSV Label is required"),
//     // zohoLabel: yup.string().required("Zoho Label is required"),
//     // dataType: yup.object().required("Data type is required"),
//     ...validationFields,
//   });
// };
